import { ReactNode } from 'react'

export const DROPDOWN_MENU_PROPS = {
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'left' as const
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'left' as const
  },
  sx: {
    '& .MuiPaper-root': {
      marginTop: '6px',
      borderRadius: '12px',
      border: '1px solid rgba(28, 42, 57, 0.10)',
      boxShadow:
        '0 16px 40px -20px rgba(18, 38, 63, 0.22), 0 2px 8px -4px rgba(18, 38, 63, 0.08)',
      backgroundColor: '#FFFFFF',
      maxHeight: 320,
      overflowY: 'auto' as const
    },
    '& .MuiList-root': {
      padding: '6px',
      backgroundColor: '#FFFFFF'
    },
    '& .MuiMenuItem-root': {
      borderRadius: '8px',
      padding: '10px 12px',
      minHeight: '40px',
      fontSize: '14px',
      lineHeight: '20px',
      color: '#30465F',
      margin: '1px 0',
      transition:
        'background-color 120ms ease, color 120ms ease, opacity 120ms ease',
      '&:hover': {
        backgroundColor: '#EEF8FD'
      },
      '&.Mui-selected': {
        backgroundColor: 'rgba(0, 164, 255, 0.10)',
        color: '#00A4FF',
        fontWeight: 500
      },
      '&.Mui-selected:hover': {
        backgroundColor: 'rgba(0, 164, 255, 0.14)'
      },
      '&.Mui-focusVisible': {
        backgroundColor: 'rgba(0, 164, 255, 0.06)'
      },
      '&.Mui-disabled': {
        opacity: 0.45
      }
    }
  }
}

interface DropdownItemContentProps {
  label: ReactNode
  description?: string
  icon?: string
  src?: string
  deprecated?: boolean
  isSelected?: boolean
  showSelectedIndicator?: boolean
  hasIconColumn?: boolean
}

export function DropdownItemContent({
  label,
  description,
  icon,
  src,
  deprecated,
  isSelected,
  showSelectedIndicator = true,
  hasIconColumn
}: DropdownItemContentProps) {
  const reserveIconColumn = hasIconColumn ?? Boolean(icon || src)

  return (
    <div className="flex w-full min-w-0 items-center gap-3">
      {reserveIconColumn && (
        <div className="flex size-5 shrink-0 items-center justify-center">
          {icon ? (
            <i className={`si ${icon} text-[18px] text-current`} />
          ) : src ? (
            // eslint-disable-next-line @next/next/no-img-element
            <img
              src={src}
              alt=""
              className="size-5 rounded-full object-cover"
            />
          ) : null}
        </div>
      )}

      <div
        className={`min-w-0 flex-1 ${deprecated ? 'opacity-50' : ''}`.trim()}
      >
        <div className="truncate">{label}</div>
        {description && (
          <div className="mt-0.5 truncate text-[12px] leading-[16px] font-normal text-ink-200">
            {description}
          </div>
        )}
      </div>

      {showSelectedIndicator && isSelected && (
        <i className="si si-check shrink-0 text-[16px] text-blue-500" />
      )}
    </div>
  )
}
